import { tw } from '@/utils/tw';

const Paragraph = tw.theme({});

export default Paragraph;
